
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const SearchBarDiv = styled.div`
    width: 180px;
    height: 28px;
    border: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;

export const SearchIcon = styled(FontAwesomeIcon)`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.primary300};
    margin-left: 5px;
`;

export const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 54px;
`;

export const Label = styled.span`
    width: 100%;
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 8px 0;
    color: ${({ theme }) => theme.colors.neutral700};
`;

export const SmallLabel = styled.span`
    color: ${({ theme }) => theme.colors.neutral700};
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    margin: ${({ margin }) => margin || '0px'};
`;
